import React from 'react';

const ProgressIndicator = ({ progress, hasUnsavedChanges }) => {
    return (
        <div className="progress-indicator">
            <div className="progress-info">
                <div className="progress-label">
                    <span>Completitud del perfil</span>
                    <span className="progress-percentage">{progress}%</span>
                </div>
                <div className="progress-bar">
                    <div
                        className="progress-fill"
                        style={{ width: `${progress}%` }}
                    />
                </div>
            </div>

            {hasUnsavedChanges && (
                <div className="save-status">
                    <div className="save-indicator unsaved">
                        <div className="status-dot unsaved" />
                        <span>Hay cambios sin guardar</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProgressIndicator;
